var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPromotions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_698_24911)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.478 12.836a.691.691 0 00-.27.544c0 .05.018.16.034.206l.84 2.658-2.184-1.631a.668.668 0 00-.8.002l-2.18 1.63.845-2.677a1.09 1.09 0 00.026-.188.692.692 0 00-.273-.546l-2.218-1.659h2.73a.67.67 0 00.641-.472l.83-2.63.833 2.633a.67.67 0 00.641.47h2.728l-2.223 1.66zm4.12-2.292a.48.48 0 00-.455-.328h-3.96l-1.227-3.88a.48.48 0 00-.916 0l-1.222 3.88H6.856a.48.48 0 00-.287.865l3.216 2.404-1.229 3.892a.477.477 0 00.456.623.48.48 0 00.288-.096l3.2-2.393 3.201 2.393a.48.48 0 00.744-.527l-1.242-3.884 3.228-2.412a.483.483 0 00.167-.537z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.995 22H6.005l-3.833-4H6a.5.5 0 000-1H1.5V7H9a.5.5 0 000-1H1.707l4-4H19.01l4.259 4H16a.5.5 0 000 1h7.5v10H19a.5.5 0 000 1h3.828l-3.833 4zm5.347-16.364l-4.792-4.5A.495.495 0 0019.208 1H5.5a.504.504 0 00-.354.146l-4.5 4.5A.504.504 0 00.5 6v11.5c0 .066.014.13.038.19.011.026.03.047.046.071.017.029.031.06.055.085l4.792 5a.5.5 0 00.361.154h13.416a.502.502 0 00.361-.154l4.792-5c.024-.025.037-.056.055-.085.016-.024.035-.045.046-.071a.511.511 0 00.038-.19V6a.497.497 0 00-.158-.364z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_698_24911"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h24v24H0z"
  })))));
}
SvgPromotions.displayName = 'Promotions';
export default SvgPromotions;